import React from "react";
import styled from "styled-components";
import { ETAPA_LABELS } from "../../../utils/toc/etapas";
import CordaTable from "./CordaTable";
import PulmaoHistogram from "./PulmaoHistogram";
import TamborTable from "./TamborTable";
import { SectionH2, SectionHeader } from "./styles";

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default function AdvancedDBRPanel({
  tambor,
  ccrEtapa,
  pulmaoHist,
  proximasLiberacoes,
  tamborDias,
}) {
  return (
    <Stack aria-label="DBR — Drum, Buffer, Rope">
      <Block>
        <SectionHeader>
          <SectionH2>
            Tambor · próximos {tamborDias} dias úteis no CCR
            {ccrEtapa ? ` (${ETAPA_LABELS[ccrEtapa]})` : ""}
          </SectionH2>
        </SectionHeader>
        <TamborTable tambor={tambor} ccrEtapa={ccrEtapa} dias={tamborDias} />
      </Block>

      <Block>
        <SectionHeader>
          <SectionH2>Pulmão · histograma de % consumido</SectionH2>
        </SectionHeader>
        <PulmaoHistogram pulmaoHist={pulmaoHist} />
      </Block>

      <Block>
        <SectionHeader>
          <SectionH2>Corda · próximas liberações para Compras</SectionH2>
        </SectionHeader>
        <CordaTable proximas={proximasLiberacoes} />
      </Block>
    </Stack>
  );
}
